import { render } from "./IconBase.vue?vue&type=template&id=0e638c3e&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"

import "./IconBase.vue?vue&type=style&index=0&id=0e638c3e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e638c3e"]])

export default __exports__